<template>
    <div class="ps">
        <div class="ps_top">
            <i class="el-icon-edit"></i>
            <div>账号管理>会员管理</div>
        </div>
        <div class="ps_search">
            <div class="search_box">
                <el-input class="" v-model="searchinput" placeholder="搜索邮箱号码"></el-input>
            </div>
            <div class="button_box">
                <el-button @click="resetting()">重置</el-button>
                <el-button @click="query()">查询</el-button>
            </div>
        </div>
        <div>
            <el-table
                :header-cell-style="{ background:'#e2d2d2'}"
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    type="index"
                    label="序号">
                </el-table-column>
                <el-table-column
                    prop="email"
                    show-overflow-tooltip
                    label="邮箱账号">
                </el-table-column>
                <el-table-column
                    label="会员等级"
                    prop="memberTypeName"
                    >
                    <!-- <template slot-scope="scope">
                        <div v-if="scope.row.memberType==1">普通会员</div>
                        <div v-if="scope.row.memberType==2">月费会员</div>
                        <div v-if="scope.row.memberType==3">终身会员</div>
                    </template> -->
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="会员到期时
                    间">
                    <template slot-scope="scope">
                        <div v-if="scope.row.memberType==1">-----</div>
                        <div v-if="scope.row.memberType!=1&&scope.row.memberType!=3">{{ scope.row.expireTime }}</div>
                        <div v-if="scope.row.memberType==3">终身有效</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="注册时间">
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="remark"
                    label="备注">
                    <!-- <template slot-scope="scope">
                        <div v-if="scope.row.remark==null"></div>
                        <div v-if="scope.row.remark!=null">{{ scope.row.remark }}</div>
                    </template> -->
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="remarks(scope.row)">添加备注</el-button>
                        <el-button type="text" @click="resettingpw(scope.row)">重置密码</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="ps_pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.currentPage"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.totalElements">
            </el-pagination>
        </div>
        <!-- 添加备注 -->
        <el-dialog
            title="添加备注"
            :visible.sync="remarksdialog"
            width="30%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="备注">
                    <el-input v-model="ruleForm.name" placeholder="最多输入20个汉字"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="remarksdialog = false">取 消</el-button>
                <el-button type="primary" @click="addremarks('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 重置密码 -->
        <el-dialog
            title="重置密码"
            :visible.sync="resettingdialog"
            class="resetting_box"
            width="30%">
            <div class="remind">
                <img src="../../assets/icons/warning.png" alt="">
                <div class="font_box">
                    <div class="font_suer">确定要重置密码吗？</div>
                    <div class="font_remind">重置密码之后，用户将重新登录~</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resettingdialog = false">取 消</el-button>
                <el-button type="primary" @click="suerresettingpw()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 重置密码信息 -->
        <el-dialog
            title="重置密码"
            :visible.sync="resettinginformationdialog"
            class="resetting_box"
            width="30%">
            <div class="remind">
                <img src="../../assets/icons/warning.png" alt="">
                <div class="font_box">
                    <div class="font_suer">重置密码成功</div>
                    <div class="font_remind">重置后密码为：{{changepassword}}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="resettinginformationdialog = false">确 定</el-button>
                <el-button type="primary"   @click="copypassword">复制密码</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                ruleForm: {
                    name: '',
                },
                rules: {
                    name: [
                        { required: true, message: '请输入备注', trigger: 'blur' },
                        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                    ],
                },
                page:{
                    pagesize:10,
                    pagescount:1,
                    totalElements:0,
                    currentPage:1
                },
                searchinput:'',
                tableData: [],
                remarksdialog:false,
                resettingdialog:false,
                resettinginformationdialog:false,
                scope:null,
                changepassword:null
            }
        },
        created(){
            this.axioslist()
        },
        methods:{
            //复制密码
            copypassword(e){
                this.$copyText(this.changepassword).then(
                    e=>{
                        this.$message({
                            message:'复制成功',
                            type:'success'
                        })
                        console.log('复制成功：', e);
                    },
                    e=>{
                        console.log('复制失败：', e);
                    }
                )

            },
            //确定重置密码
            suerresettingpw(){
                this.$http.put(`/resetPassword/member?id=${this.scope.id}`).then((res)=>{
                    if(res.code==200){
                        // console.log(111,res);
                        this.resettingdialog=false;
                        this.resettinginformationdialog=true
                        this.changepassword=res.message
                    }
                })
            },
            //重置密码
            resettingpw(scope){
                this.scope=scope;
                this.resettingdialog=true;

            },
            //点击添加备注
            remarks(scope){
                console.log(111111,scope);
                this.remarksdialog=true;
                this.scope=scope
                this.ruleForm.name=this.scope.remark
            },
            //添加备注确定
            addremarks(){
                
                let obj={
                    "id": this.scope.id,
                    "remark": this.ruleForm.name
                }
                console.log('备注',obj);
                this.$http.put('/remark/member',obj).then((res)=>{
                    if(res.code==200){
                        this.$message({
                            message:'添加备注成功',
                            type:'success'
                        })
                        this.remarksdialog=false;
                        this.ruleForm.name="";
                        this.axioslist()
                    }
                })
                    
                
            },
            //重置
            resetting(){
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1
                this.searchinput='';
                this.axioslist()
            },
            //查询
            query(){
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1
                this.axioslist()
            },
             //请求数据列表
             axioslist(){
                let obj={
                    pageIndex:this.page.pagescount,//页码
                    pageSize:this.page.pagesize,//页面大小
                    key:this.searchinput,//描述
                }
                // console.log(111,Number( type));
                this.$http.get(`/page/member?pageIndex=${this.page.pagescount}&pageSize=${this.page.pagesize}&key=${this.searchinput}`).then((res)=>{
                    if(res.code==200){;
                        this.page.totalElements=res.data.totalElements
                        this.tableData=res.data.data;

                    }
                })
            },
            handleCurrentChange(val){
                this.page.pagescount=val;
                this.page.currentPage=val;
                this.axioslist()
            },
            handleSizeChange(val){
                this.page.pagesize=val;
                this.axioslist()
            },
        }
    }
</script>

<style lang="less" scoped>
.resetting_box{
    .remind{
        display: flex;
        justify-content: center;
        align-items: center;
        .font_box{
            margin-left: 20px;
            .font_suer{
                color: #333333;
                font-weight: bold;
                font-size: 25px;
            }
            .font_remind{
                color: #666666;
            }
        }
    }
}
.ps{
    width: 100%;
    height: 100%;
    box-sizing: border-box ;
    background: #fff;
    min-height: 829px;
    padding: 10px 20px;
    .ps_top{
            width: 100%;
            height: 20px;
            display: flex;
            align-items: center;
            box-sizing: border-box
        }
    .ps_search{
        box-sizing: border-box;
        width:100%;
        height: 50px;
        border: 1px solid #d7d7d7;
        margin: 10px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0px;
        .search_box{
            box-sizing: border-box;
            padding-left: 20px;
            width: 300px;
        }
        .button_box{
            box-sizing: border-box;
            padding-right: 20px;
        }
    }
    .ps_pagination{
        width: 100%;
        height: 5%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: right;
    }
}
</style>